import { browserTracingIntegration, init } from "@sentry/react";
import { shouldIgnoreSentryErrorMessage } from "./filters";

export const initSentry = (options: {
  /**
   * Sentry DSN
   */
  dsn: string;
  /**
   * Release number of current build
   */
  release: string;

  /**
   * Environment of current build
   */
  environment: string;

  /**
   * Whether to enable debug mode
   */
  debug: boolean;

  /**
   * Whether to enable tracing
   */
  tracePropagation: string[];
}) => {
  init({
    dsn: options.dsn,
    debug: options.debug,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 1,
    tracePropagationTargets: options.tracePropagation,
    release: options.release,
    environment: options.environment,
    attachStacktrace: true,
    beforeSend: (event) => {
      const exceptionMessage = event.exception?.values?.[0]?.value;
      const eventMessage = event.message;
      if (
        shouldIgnoreSentryErrorMessage(exceptionMessage) ||
        shouldIgnoreSentryErrorMessage(eventMessage)
      ) {
        return null;
      }

      if (event.request) {
        delete event.request.headers?.authorization;
      }

      return event;
    },
  });
};
